module.exports = __webpack_public_path__ + "assets/img/img148.071d6567.png";